export default [
    {
        path: 'relatorio-estatistico',
        component: () => import(
            /* webpackChunkName: 'transporte-paciente-relatorio-estatistico' */
            '@/views/transporte-paciente/relatorio-estatistico/Index'
        ),
        redirect: 'relatorio-estatistico/index',
        children: [
            {
                name: 'transporte-paciente-relatorio-estatistico-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'transporte-paciente-relatorio-estatistico' */
                    '@/views/transporte-paciente/relatorio-estatistico/List.vue'
                ),
            },
        ],
    },
]
